export default __webpack_public_path__ + "./images/empty-avatar.0ca3d123.svg";